export * as BREAKPOINTS from './constants/breakpoints'
export * as COLORS from './constants/colors'
export * as EFFECTS from './constants/effects'
export * as FONTS from './constants/fonts'
export * as TYPOGRAPHY from './constants/typography'
export * as SIZES from './constants/sizes'
export * as ZINDEX from './constants/zindex'

export * as behaviours from './behaviours'
export * as glyphs from './icons/glyphs'
export * as hooks from './hooks'
export * as illustrations from './icons/illustrations'
export * as logos from './icons/logos'
export * as styles from './styles'
export * as utils from './utils'

if (typeof window !== 'undefined') {
  ;(window as any).OWL_KIT_COMPONENTS_VERSION = 'OWL_KIT_VERSION / OWL_KIT_ENV'
}

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && typeof window !== 'undefined') {
  console.warn('[owl-kit-components] You currently use the non-production bundle of the library.') // eslint-disable-line no-console
  console.info(`owl-kit-components version: ${(window as any).OWL_KIT_COMPONENTS_VERSION}-next`) // eslint-disable-line no-console
}

export * from './components'

export * from './core/accounting/Accounting'
export * as accounting from './core/accounting'
export { NUMBER_FORMAT_CONFIG } from './core/accounting'

export { GlobalStyleDesignSystem, LockScrollGlobalStyle } from './theme'
